import { toast } from "react-toastify";

export function adminActor() {
  return {
    adminId: localStorage.getItem("adminId") || "",
    adminName: localStorage.getItem("adminName") || "",
    adminUserName: localStorage.getItem("userData") || "",
  };
}

export const STATUS_META = {
  searching: { label: "Searching", tone: "bg-sky-50 text-sky-700" },
  offered: { label: "Offered", tone: "bg-amber-50 text-amber-700" },
  accepted: { label: "Accepted", tone: "bg-emerald-50 text-emerald-700" },
  completed: { label: "Completed", tone: "bg-green-100 text-green-800" },
  cancelled: { label: "Cancelled", tone: "bg-slate-200 text-slate-700" },
  unassigned: { label: "Unassigned", tone: "bg-red-100 text-red-700" },
  legacy: { label: "Legacy", tone: "bg-slate-100 text-slate-500" },
};

export function SOSStatusBadge({ status }) {
  const meta = STATUS_META[status || "legacy"] || { label: status, tone: "bg-slate-100 text-slate-600" };
  return <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${meta.tone}`}>{meta.label}</span>;
}

export function formatIST(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "-";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "numeric", minute: "2-digit", hour12: true,
  }).formatToParts(d).reduce((a, p) => ({ ...a, [p.type]: p.value }), {});
  return `${parts.day} ${parts.month}, ${parts.hour}:${parts.minute} ${String(parts.dayPeriod || "").toLowerCase()}`;
}

export const fmtKm = (v) => (v == null || v === "" || isNaN(Number(v)) ? "-" : `${Number(v).toFixed(1)} km`);

/** Calls an api fn, toasts the Message, returns the response when IsSuccess. */
export async function runAction(fn, okMessage) {
  try {
    const res = await fn();
    if (res && res.IsSuccess) {
      if (okMessage) toast.success(res.Message || okMessage);
      return res;
    }
    toast.error((res && res.Message) || "Something went wrong");
  } catch (e) {
    toast.error(e?.response?.data?.Message || e?.message || "Something went wrong");
  }
  return null;
}

export function ModalShell({ title, onClose, children, footer, wide = "max-w-lg" }) {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto rm-modal">
      <div className="flex items-center justify-center min-h-screen px-2 sm:px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-50 backdrop-blur-sm rm-modal-backdrop" onClick={onClose}></div>
        <div className={`rm-dialog inline-block align-bottom bg-white rounded-t-lg sm:rounded-lg text-left overflow-hidden shadow-2xl transform transition-all w-full ${wide} sm:my-8 sm:align-middle sm:w-full`}>
          <div className="sticky top-0 bg-white border-b border-gray-200 px-4 sm:px-6 py-4 z-10 flex items-center justify-between">
            <div className="min-w-0 text-lg font-semibold text-gray-900">{title}</div>
            <button onClick={onClose} className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="px-4 sm:px-6 py-4">{children}</div>
          {footer ? <div className="sticky bottom-0 bg-white border-t border-gray-200 px-4 sm:px-6 py-4 shadow-lg">{footer}</div> : null}
        </div>
      </div>
    </div>
  );
}

export const btnPrimary = "inline-flex items-center justify-center rounded-lg px-4 py-2 bg-primary-600 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed";
export const btnGhost = "inline-flex items-center justify-center rounded-lg border border-gray-300 px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed";
export const btnDanger = "inline-flex items-center justify-center rounded-lg px-4 py-2 bg-red-600 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed";
